import { render, staticRenderFns } from "./cursos-detalles.vue?vue&type=template&id=78d15a15&scoped=true&"
import script from "./cursos-detalles.vue?vue&type=script&lang=ts&"
export * from "./cursos-detalles.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-detalles.vue?vue&type=style&index=0&id=78d15a15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d15a15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VContainer,VRow,VSpacer})
